<template>
  <div id="login">
    <div class="asdada">
      <div class="login_list">
        <div class="register_logo">
          <img style="width: 190px" src="@/assets/login/logo.png" alt />
          <span class="text">一体化企业管理云应用</span>
        </div>
      </div>
      
      
      <div class="login_bxo">
        <ul>
          <li :index="index + 1 + ''" v-for="(obj, index) in list" :key="index">
            <p>
              <img :src="obj.img" alt />
              <span @click="ahkjhkj(obj.path)">
                <!-- <a :href="obj.path">{{ obj.text }}</a> -->
                {{ obj.text }}
              </span>
            </p>
          </li>
        </ul>
        <el-tabs v-model="activeName">
          <el-tab-pane label="账号登录" name="first">
            <div class="login_form">
              <el-form
                :model="ruleForm"
                status-icon
                :rules="rules2"
                ref="ruleForm"
                class="demo-ruleForm"
              >
                <el-form-item prop="phone">
                  <el-input
                    v-model.number="ruleForm.phone"
                    placeholder="请输入账号/手机号"
                    prefix-icon="el-icon-s-custom"
                    @keyup.enter.native="submitForm('ruleForm')"
                    @focus="inputFocus"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input
                    type="password"
                    v-model="ruleForm.pass"
                    :auto-complete="complete == false ? 'new-password' : ''"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                    @focus="focus"
                    :show-password="true"
                    @keyup.enter.native="submitForm('ruleForm')"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <div
                    style="width: 240px; margin-left: 25px; margin-bottom: 17px"
                    v-if="confirmSuccessshow"
                  >
                    <!-- v-if="ruleForm.phone !=''&&  ruleForm.pass !=''" -->
                    <Drag
                      ref="footer"
                      class="Drag"
                      @confirmSuccess="confirmSuccess"
                      @keyup.enter.native="submitForm('ruleForm')"
                    />
                  </div>
                  <el-button
                    type="primary"
                    @click="submitForm('ruleForm')"
                    class="login_btn"
                    ><!-- <a style="margin: auto;" id="ssss" href="webprint://" >登录</a> -->登录</el-button
                  >
                  <!-- :disabled="disabledshow" -->
                  <!-- <el-button
                    type="primary"
                    @click="loginGoRegister('ruleForm')"
                    class="login_btn2"
                    >新用户注册</el-button
                  > -->
                  <div class="login_btn2">
                     <span @click="loginGoRegister('1')">忘记密码</span>
                  </div>
                </el-form-item>
              </el-form>
              <p>服务热线 : 028-84210089 69868811</p>
            </div>
          </el-tab-pane>
       
        </el-tabs>
        <div class="remember">
          <!-- <div class="Password">忘记密码</div> -->
        </div>
           <div class="flexd">
            <div class="xiazai">
              <img src=".././../assets/An.png" alt="" />
              <p>安卓下载</p>
            </div>

            <div class="xiazai">
              <img src=".././../assets/IOS.png" alt="" />
              <p>IOS下载</p>
            </div>
          </div>
      </div>
      <div class="login_logo">
        <ul>
          <li>纯BS架构 云端管理</li>
          <li>进销存丶财务丶OA丶商城一体化管理解决方案</li>
        </ul>
        <img src="../../assets/login/登录.png" alt />
        <div class="tese">
          <div class="understand" @click="moreclick">了解更多...</div>
        </div>
      </div>
    </div>
    <div class="footer">版权所有 <span style="padding: 0 12px;"> @ </span> 成都升通达软件有限公司</div>
  </div>
</template>

<script>
import tool from "@/utils/tool";
import MD5 from "@/utils/md5";
import { passwordReg } from "@/utils/validator";
import Drag from "@/components/Common/Drag/Drag";

export default {
  components: {
    Drag,
  },
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不能为空"));
      } else if (/^1[345678]\d{9}$/.test(this.phone)) {
        callback(new Error("请输入正确是手机号"));
        // return false
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          // callback();
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        // 非空验证
        callback(new Error("密码不能为空")); // 错误提示
      } else {
        // callback(); // 成功回调
      }
    };

    return {
      confirmSuccessshow: false,
      complete: false, //是否允许浏览器记住密码数据回填 true 允许  false 不允许
      disabledshow: false,
      yzms: "",
      value1: 0,
      herf: "",
      activeName: "first",
      ruleForm: {
        pass: "",
        phone: "",
      },
      time: "",
      disabled: false, //是否可点击
      checked: false,
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        phone: [{ validator: checkAge, trigger: "blur" }],
      },
      list: [
        // {
        //   img: require("../../assets/images/yun.png"),
        //   text: "返回主页"
        // },
        {
          img: require("../../assets/images/home.png"),
          text: "进入官网",
          path: "http://www.sdasoft.com.cn",
        },
        {
          img: require("../../assets/images/lianxiwomen.png"),
          text: "联系我们",
          path: "http://www.sdasoft.com.cn/c_main/contact.php",
        },
      ],
    };
  },
  // directives:{
    // trigger:{
      // inserted(el,binging){ 
        // console.log( tool.getLocal("userid"));
        // el.click()
      // }
    // }
  // },
  methods: {
    moreclick() {
      window.open("http://www.sdasoft.com.cn/c_main/productread.php?cs=169");
    },
    ahkjhkj(path) {
      window.open(path); // 去哪儿
      // window.opener()  //回哪儿
    },
    confirmSuccess(Ble) {
      if (Ble) {
        this.disabledshow = Ble;
        this.userdata();

        setTimeout(() => {
          this.submitForm();
        }, 200);
      }
    },
    userdata() {
      let vm = this;
      let jparams = {
        command: 2004,
      };
      this.request
        .post("http://118.190.210.223:10003/user3.php", {
          jparams: JSON.stringify(jparams),
        })
        .then((res) => {
          let { yzm, result } = res;
          if (result.accept == "1") {
            vm.yzms = yzm;
          }
        });
    },
    // 红冲权限
    Initializa(userid, sessionid) {
      tool.removeSession("get_config");
      let jparams = {
        user_id: userid, //用户id
        session_id: sessionid, //用户凭证
      };
      this.request
        .post("/index/Settings/get_config", {
          jparams: JSON.stringify(jparams),
        })
        .then((res) => {
          let { status, data } = res;
          if (status == 0) {
            tool.saveLocal("get_config", data);
          }
        });
    },
    // // 岗位 按钮权限
    ButtonPower(userid, sessionid) {
      //   tool.removeLocal("Button_Power");
      //   let jparams = {
      //     user_id: userid, //用户id
      //     session_id: sessionid //用户凭证
      //   };
      //   this.request
      //     .post("/index/Privileges/get_user_group_priv", {
      //       jparams: JSON.stringify(jparams)
      //     })
      //     .then(res => {
      //       let { status, data } = res;
      //       if (status == 0) {
      //         tool.saveLocal("Button_Power", data);
      //       }
      //     });
    },
    inputFocus() {
      event.currentTarget.select();
    },
    focus(val) {
      val.target.value = "";
    },
    submitForm(formName) {
      if (this.confirmSuccessshow) {
        if (
          this.ruleForm.pass != "" &&
          this.ruleForm.phone != "" &&
          this.disabledshow == true
        ) {
          var str = this.ruleForm.pass;
          let a = str.MD5(32); // 32位加密方法
          var times = Date.parse(new Date());
          let params = {
            command: 1002,
            yzm: this.yzms.MD5(32),
            user: {
              user_login: this.ruleForm.phone,
              user_pwd: a,
            },
          };
          let jparams = JSON.stringify(params);
          let jparams_login = { jparams: jparams };
          this.request
            .post("http://118.190.210.223:10003/user3.php", jparams_login)
            .then((res) => {
              // 接收参数
              let { result, command, user } = res;
              // 判断
              if (result.accept == 1) {
                // document.getElementById('ssss').click()
                // 弹成功提示
                this.$message({
                  showClose: true,
                  message: "登录成功",
                  type: "success",
                  duration: 1000,
                });
                tool.saveLocal("username", this.ruleForm.phone);
                tool.saveLocal("password", this.ruleForm.pass);
                tool.saveLocal("U_tok_token", true);
                tool.saveLocal("userid", user.user_id);
                tool.saveLocal("sessionid", user.session_id);
                tool.saveLocal("user", user);
                tool.saveLocal("EtypeId", user.EtypeId);
                tool.saveLocal("FullName", user.FullName);
                tool.saveLocal("companyid", user.company_id);
                tool.saveLocal("dbid", user.db_id);
                tool.saveLocal("main", user.main);
                tool.saveLocal("endtime", user.end_time);
                tool.saveSession("times", times);
                tool.saveSession("location_href", "location.href");
                tool.saveSession("location_href1", "location.href");
                tool.saveSession("Button_click", true);
                this.Initializa(user.user_id, user.session_id);
                // this.ButtonPower(user.user_id, user.session_id);
                this.$router.push("/home"); // 跳后端首页
              } else if (result.accept == 0) {
                // this.$refs.footer.childAction();
                // this.disabledshow = false;
                this.confirmSuccessshow = false;
                // 失败
                this.$message({
                  showClose: true,
                  message: result.description,
                  type: "error",
                  duration: 2000,
                });
              } else {
                this.$message({
                  showClose: true,
                  message: result.description,
                  type: "error",
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              //返回错误信息
              this.errors = {
                code: error.response.data.msg,
              };
            });
        } else if (!this.ruleForm.phone || !this.ruleForm.pass) {
          this.$message({
            message: "账号密码不能为空",
            type: "warning",
            duration: 1000,
          });
        } else if (!this.disabledshow) {
          this.$message({
            message: "请拖动滑滑块验证",
            type: "warning",
            duration: 1000,
          });
        }
      } else {
        if (this.ruleForm.pass != "" && this.ruleForm.phone != "") {
          this.confirmSuccessshow = true;
        }
      }
    },
    loginGoRegister(type) {
      this.$router.push("/record?type="+type); // 跳后端首页
    },
  },
  created() {
    tool.removeLocal("U_tok_token");
    if (
      tool.getSession("location_href") == tool.getSession("location_href1") &&
      tool.getSession("location_href") != null &&
      tool.getSession("location_href1") != null
    ) {
      this.$message({
        showClose: true,
        message:
          "您的账号存在风险,请注意帐号安全。如非本人操作，可能密码已泄漏，建议到个人设置页面修改密码!",
        type: "warning",
      });
      tool.removeSession("location_href");
      tool.removeSession("location_href1");
    }
  },
  watch: {},
};
</script>

<style lang="less" >
@import "./login.less";
</style>


// WEBPACK FOOTER //
// src/Views/Login/login.vue